import React from 'react';

const Payback = () => {
    return (
        <section className="payback-section container mx-auto mb-10">
		<div className=" bg-gradient-to-r from-accent via-yellow-400 to-primary   rounded-3xl shadow-xl w-10/12 lg:w-full mx-auto">
            
			<div className="hero-content  lg:flex-row flex-col max-w-full items-center p-0 justify-between">
            
                <div className="lg:w-5/12 w-10/12">
					<img
						src={process.env.PUBLIC_URL + "img/payback.png"}
						className="lg:items-end items-start justify-center "
						alt="hero-header"
					/>
				</div>
				<div className="lg:w-5/12 py-20 w-10/12">
					<h1 className="lg:text-8xl md:text-7xl text-3xl font-bold skew-y-12">
						<span className="bg-neutral text-white px-6 lg:text-9xl text-4xl">
                        PAYDAY < br/>	
                            </span>
                            SALE NOW.
					</h1>
					<p className="py-2 w-80 text-black">
                    Spend minimal $100 get 30% off
                    voucher code for your next purchase
					</p>
					<p className="py-2 text-black">
                    1 June - 10 June 2021
                    *Terms & Conditions apply
					</p>
					<button className="btn btn-secondary mx-auto w-72">Shop Now</button>
				</div>
		
       
                </div>
		</div>
        </section>
    );
};

export default Payback;